export enum ECohortStatus {
  PENDING = 'PENDING',
  WAITING = 'WAITING',
  ACCEPTED = 'ACCEPTED',
  ACTIVATED = 'ACTIVATED',
  DENIED = 'DENIED',
  VALIDATING = 'VALIDATING'
}
